import React, { FC, useEffect } from 'react';
import classNames from 'classnames/bind';
import { Modal, Text, Title } from '@carnica/ui-kit';
import { useIsDesktopDimension } from '@carnica/utils/hooks';

import { Image } from '../Image';
import { AppIconsBlock } from './components/AppIconsBlock';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

type AppModalPropsType = {
  image: string;
  isOpen: boolean;
  onClose: () => void;
  portalProps?: Record<string, string>;
  qrCode: string;
  subtitle: string;
  text: string;
  title: string;
};

export const AppModal: FC<AppModalPropsType> = ({
  image,
  onClose,
  isOpen,
  title,
  subtitle,
  qrCode,
  text,
  portalProps,
}) => {
  const isDesktop = useIsDesktopDimension();
  useEffect(() => {
    if (!isDesktop) {
      onClose();
    }
  }, [isDesktop]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} portalClassName={cn('hub')} portalProps={portalProps}>
      <div className={cn('container')}>
        <div className={cn('block-big')}>
          <Image className={cn('image')} height={64} src={image} width={64} />
        </div>
        <Title align="center" className={cn('title')} size="l" title={title} />
        <Text color="secondary" size={20}>
          {subtitle}
        </Text>
        <div className={cn('block-small')}>
          <Image className={cn('image')} height={230} src={qrCode} width={230} />
        </div>
        {text && (
          <Text color="primary" size={16}>
            {text}
          </Text>
        )}
        <AppIconsBlock />
      </div>
    </Modal>
  );
};
